import React, { memo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import LargeLabel from '../../LargeLabel';
import Repeat from '../../Repeat';
import Skeleton from '../../Skeleton';

const TableWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: auto;
  z-index: 10;
`;

const DefaultRowSkeleton = () => (
  <div className="rt-td">
    <LargeLabel><Skeleton width="300px" /></LargeLabel>
  </div>
);

const DataTableSkeleton = ({ children }) => (
  <TableWrapper className="rt-table">
    <div className="rt-thead -header" style={{ height: '45px' }}>
      &nbsp;
    </div>
    <div className="rt-tbody">
      <Repeat
        times={10}
        render={(i) => (
          <div className="rt-tr-group" key={i}>
            <div className="rt-tr">
              {children}
            </div>
          </div>
        )}
      />
    </div>
  </TableWrapper>
);
DataTableSkeleton.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};
DataTableSkeleton.defaultProps = {
  children: <DefaultRowSkeleton />,
};

export default memo(DataTableSkeleton);
